// export const CLIENT = process.env.REACT_APP_CLIENT || "default";
export const CLIENT = localStorage.getItem('clientIdentityName') || "default";

export const setClientIdentity = (clientIdentityName) => {
    localStorage.setItem('clientIdentityName', clientIdentityName);
}

export const getClientIdentity = () => {
    return localStorage.getItem('clientIdentityName');
}

export const clearClientIdentity = () => {
  localStorage.removeItem('clientIdentityName');
};